import Search from './Search'

const FilterBar = () => {
  return (
    <div className="w-full flex flex-col gap-4 justify-center items-center p-4 md:p-8">
      <Search />
    </div>
  )
}

export default FilterBar
